import { UntypedFormControl } from '@angular/forms';

export function dateBeforeOtherValidator(otherControlName: string) {
  let thisControl: UntypedFormControl;
  let otherControl: UntypedFormControl;

  return function validateDates(control: UntypedFormControl) {
    if (!control.parent) {
      return null;
    }

    if (!thisControl) {
      thisControl = control;
      otherControl = control.parent.get(otherControlName) as UntypedFormControl;
      // console.log(otherControl);
      if (!otherControl) {
        throw new Error('dateBeforeOtherValidator(): other control is not found in parent group');
      }
      // otherControl.valueChanges.subscribe(() => {
      //     thisControl.updateValueAndValidity();
      // });
    }

    if (!otherControl) {
      return null;
    }

    const otherBeforeThis = new Date(otherControl.value)?.getTime() < new Date(thisControl.value)?.getTime();

    if (otherControl.value && thisControl.value && otherBeforeThis) {
      return {
        datesRange: true,
      };
    }

    return null;
  };
}
